module.exports = "<p>\nCurrent Link is Expired.\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/registration/sainik-account/sainik-account.component.html
// module id = ./src/app/registration/sainik-account/sainik-account.component.html
// module chunks = main